import React, { useEffect } from "react";
import Header from "./header";
import Summary from "./summary";
import Videos from "./videos";
import Testimonials from "./testimonials";
import CollapseView from "./collapse-view";
import Bottom from "./bottom-cat";

import { useSelector, useDispatch } from "react-redux";
import { resetFallbackMessage } from "../../../redux/actions/universal";
import {
  sendErrorNotification,
  sendSuccessNotification,
} from "../../universal/notifications/notifications";
import { ToastContainer } from "react-toastify";

const Index = () => {
  const dispatch = useDispatch();
  const error = useSelector((state) => state.universal?.errorNotification);
  const success = useSelector((state) => state.universal?.successNotification);

  useEffect(() => {
    if (error) {
      sendErrorNotification(error);
      dispatch(resetFallbackMessage());
    }

    if (success) {
      sendSuccessNotification(success);
      dispatch(resetFallbackMessage());
    }
  }, [error, success]);

  return (
    <div>
      <Header />
      <Videos />
      <Testimonials />
      <CollapseView />
      <Bottom />
      <ToastContainer />
    </div>
  );
};

export default Index;
